import { Component } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

@Component({
  selector: 'fin-corporate-benefits-widget',
  templateUrl: './corporate-benefits-widget.component.html',
  styleUrl: './corporate-benefits-widget.component.scss',
})
export class CorporateBenefitsWidgetComponent {
  protected readonly SvgLibraryIcon = SvgLibraryIcon;
}
